import { InputField } from '@wienenergiegithub/ui-next';
import styles from './InputFieldNumeric.module.scss';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import classNames from 'classnames';

const handleKeyPress = (event, isDecimal) => {
  const regex = isDecimal ? /[0-9,]/ : /[0-9]/;

  if (!regex.test(event.key)) {
    event.preventDefault();
  }
};

const InputFieldNumeric = forwardRef(
  ({ className, isDecimal = false, store, ...props }, ref) => (
    <InputField
      className={classNames(styles.numericField, className)}
      onKeyPress={event => handleKeyPress(event, isDecimal)}
      ref={ref}
      store={store}
      {...props}
    />
  ),
);

InputFieldNumeric.propTypes = {
  className: PropTypes.string,
  isDecimal: PropTypes.bool,
  /* eslint-disable react/forbid-prop-types */
  /** `useFormStore()` return value from `@ariakit/react` */
  store: PropTypes.object.isRequired,
};

InputFieldNumeric.displayName = 'InputFieldNumeric';

export default InputFieldNumeric;
